(() => {
  const wrapper = document.querySelector('.blog-post-content');
  if (!wrapper || wrapper.dataset.pvEnhanced === 'true') return;
  wrapper.dataset.pvEnhanced = 'true';

  const content = wrapper.querySelector(':scope > rte-formatter') || wrapper;

  const hasFullCustomLayout = content.querySelector(
    '.pv-article-callout, .pv-article-toc, .pv-article-flow, .pv-article-mistakes, .pv-article-checklist, .pv-article-cta, .pv-article-faq'
  );
  if (hasFullCustomLayout) return;

  const directChildren = [...content.children];
  const h2s = directChildren.filter((el) => el.tagName === 'H2');
  if (!h2s.length) return;

  const slugify = (text) =>
    text
      .toLocaleLowerCase('lt-LT')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9ąčęėįšųūž]+/gi, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 70);

  const usedIds = new Set();
  h2s.forEach((heading, index) => {
    if (!heading.id) {
      let base = slugify(heading.textContent.trim()) || `skyrius-${index + 1}`;
      let id = base;
      let suffix = 2;
      while (usedIds.has(id) || document.getElementById(id)) id = `${base}-${suffix++}`;
      heading.id = id;
    }
    usedIds.add(heading.id);
    heading.classList.add('pv-auto-section-title');
  });

  const firstH2Index = directChildren.indexOf(h2s[0]);
  const beforeFirstHeading = directChildren.slice(0, firstH2Index);
  const introParagraphs = beforeFirstHeading.filter((el) => {
    if (el.tagName !== 'P') return false;
    if (!el.textContent.trim()) return false;
    if (el.querySelector('a[href^="/products/"], a[href^="/pages/"], a[href^="/collections/"]')) return false;
    return true;
  }).slice(0, 2);

  let anchorBefore = content.firstElementChild;
  if (introParagraphs.length) {
    const intro = document.createElement('div');
    intro.className = 'pv-auto-intro';
    intro.innerHTML = '<p class="pv-auto-intro__eyebrow">TRUMPAI</p>';
    introParagraphs.forEach((paragraph) => intro.appendChild(paragraph));
    content.insertBefore(intro, anchorBefore);
    anchorBefore = intro.nextElementSibling;
  }

  if (h2s.length >= 3) {
    const toc = document.createElement('nav');
    toc.className = 'pv-auto-toc';
    toc.setAttribute('aria-label', 'Straipsnio turinys');
    const links = h2s
      .slice(0, 9)
      .map((heading) => `<a href="#${heading.id}">${heading.textContent.trim()}</a>`)
      .join('');
    toc.innerHTML = `<p class="pv-auto-toc__title">ŠIAME STRAIPSNYJE</p><div class="pv-auto-toc__links">${links}</div>`;

    const intro = content.querySelector(':scope > .pv-auto-intro');
    if (intro) intro.insertAdjacentElement('afterend', toc);
    else content.insertBefore(toc, content.firstElementChild);
  }

  [...content.children].forEach((el) => {
    if (el.tagName === 'UL') {
      const count = el.children.length;
      const previousHeading = el.previousElementSibling?.tagName === 'H2' ? el.previousElementSibling.textContent : '';
      const skip = /oficialūs? šaltiniai|šaltiniai/i.test(previousHeading || '');
      if (!skip && count >= 4 && count <= 12 && !el.className) {
        el.classList.add('pv-auto-list');
      }
    }

    if (el.tagName === 'P') {
      const links = [...el.querySelectorAll('a')];
      if (links.length !== 1 || el.textContent.trim().length > 135) return;
      const link = links[0];
      const href = link.getAttribute('href') || '';
      if (!/^\/(products|pages|collections)\//.test(href)) return;
      el.classList.add('pv-auto-cta-row');
      link.classList.add('pv-auto-cta');
    }
  });
})();
